<template>
  <div>
    <div v-if="hadSubmitted" class="columns">
      <div class="columns-chart">
        <el-card v-loading="loading" class="chart-container" shadow="always">
          <el-row>
            <div class="flex-row align-center justify-end">
              <el-button v-if="testRole"
                type="primary"
                size="small"
                @click="settingShare"
                :plain="true"
              >
                {{ $t('chart.sync') }}
              </el-button>
              <el-button
                type="primary"
                size="small"
                @click="toggleShowTable($event)"
                :plain="!showTable"
              >
                {{ $t('chart.table') }}
              </el-button>
              <!--enableRain1Day-->
              <el-tooltip
                :content="$t('chart.info.trendline')"
                class="ml-8"
                placement="top"
              >
                <el-button @click="toggleTrendline($event)" :plain="!enableTrendline" type="primary" size="small">
                  {{$t('chart.trendline')}}
                </el-button>
              </el-tooltip>
              <el-tooltip
                :content="$t('chart.info.rain1Day')"
                v-if="!kmrtRole"
                class="ml-8"
                placement="top"
              >
                <el-button @click="toggleShowRain1Day" :plain="!enableRain1Day" type="primary" size="small">
                  {{$t('chart.rain1Day')}}
                </el-button>
              </el-tooltip>
              <el-tooltip
                v-if="enable1HrVelocity"
                :content="$t('chart.velocity1Hr')"
                class="ml-8"
                placement="top"
              >
                <el-button @click="toggleShowVelocity1Hr" :plain="!showVelocity1Hr" type="primary" size="small">
                  <!--font-awesome-icon v-if="!showRemark" icon="eye" /-->
                  <!--font-awesome-icon icon="eye-slash" /-->
                  {{'1Hr'}}
                </el-button>
              </el-tooltip>
              <el-tooltip
                v-if="enable24HrVelocity"
                :content="$t('chart.velocity24Hr')"
                class="ml-8"
                placement="top"
              >
                <el-button @click="toggleShowVelocity24Hr" :plain="!showVelocity24Hr" type="primary" size="small">
                  <!--font-awesome-icon v-if="!showRemark" icon="eye" /-->
                  <!--font-awesome-icon icon="eye-slash" /-->
                  {{'24Hr'}}
                </el-button>
              </el-tooltip>
              <el-tooltip
                :content="showRemark ? $t('chart.remark.hide') : $t('chart.remark.show')"
                class="ml-8"
                placement="top"
              >
                <el-button @click="toggleShowRemark" type="primary" size="small">
                  <font-awesome-icon v-if="!showRemark" icon="eye" />
                  <font-awesome-icon v-if="showRemark" icon="eye-slash" />
                </el-button>
              </el-tooltip>
              <el-divider direction="vertical" />
              <el-tooltip :content="$t('chart.rescale')" class="ml-8" placement="top">
                <el-button @click="rescaleChartBtn('yAxisRule_rescale')" type="primary" size="small">
                  <font-awesome-icon icon="sync-alt" />
                </el-button>
              </el-tooltip>
              <el-divider direction="vertical" />
              <el-button
                v-for="(button, index) in chartDateRangeList"
                :key="button.name"
                :class="{ 'is-plain': index !== chartActiveIndex }"
                @click.prevent="set_x_AxisTickInterval(index, button.day, button.hours)"
                size="small"
                type="primary"
              >
                {{ button.name }}
              </el-button>
              <el-button
                slot="reference"
                :class="{
                  'is-plain': chartActiveIndex !== chartDateRangeList.length,
                }"
                @click="showSettings = true"
                type="primary"
                size="small"
              >
                <font-awesome-icon icon="cog" />
              </el-button>
            </div>
          </el-row>
          <highcharts ref="highcharts" :options="chartOptions" />
        </el-card>
      </div>
    </div>
    <remark-form
      v-if="remark.show"
      :editing-remark="remark.editing"
      :instrument="remark.instrument"
      :timestamp="remark.timestamp"
      :form-type="remark.formType"
      @close="onRemarkFormClose"
      @success="onRemarkUpdate"
    />
    <el-drawer
      :title="$t('chart.settings')"
      :visible.sync="showSettings"
      :modal="false"
      :size="$device.mobile ? '100%' : '30%'"
      :before-close="handleCloseDrawer"
    >
      <div class="flex-column" style="padding:0 20px;">
        <h6 class="title is-6">
          {{ $t('chart.date.interval') }}
        </h6>
        <div class="flex-row">
          <div class="flex-row">
            <el-input-number
              v-model="customize.xAxisTickInterval.day"
              :min="0"
              :placeholder="$t('chart.date.day')"
              size="small"
            /><span class="input-label-right">{{ $t('chart.date.day') }}</span>
          </div>
          <div class="flex-row" style="margin-left: 10px;">
            <el-input-number
              v-model="customize.xAxisTickInterval.hours"
              :min="0"
              :max="24"
              :placeholder="$t('chart.date.hour')"
              size="small"
            /><span class="input-label-right">{{ $t('chart.date.hour') }}</span>
          </div>
        </div>
        <h6 class="title is-6" style="margin-top: 20px;">
          {{ $t('chart.instrument.alert') }}
        </h6>
        <div class="flex-row align-center">
          <el-select v-model="alertInstrument._id" @change="updateYAxis">
            <el-option
              v-for="instrument in selectedInstrument"
              :key="instrument._id"
              :value="instrument._id"
              :label="instrument.latestVersion.name"
            />
          </el-select>
          <el-checkbox-group
            v-model="alertInstrument.showTarget"
            @change="updateYAxis"
            style="margin-left: 20px;"
          >
            <el-checkbox label="WL">注意值</el-checkbox>
            <el-checkbox label="AL">警戒值</el-checkbox>
            <el-checkbox label="WSL">行動值</el-checkbox>
          </el-checkbox-group>
        </div>
        <div v-if="!loading" class="flex-column" style="padding: 20px 0;">
          <el-card
            v-for="(unit, index) in cloneOptions.yAxis"
            :key="unit.id"
            v-show="!unit.duplicated"
            style="margin-bottom: 10px;"
            shadow="hover"
            :style="{ 'border-top': `4px solid ${unit.gridLineColor}` }"
          >
            <div class="content">
              <div class="flex-row align-center justify-between" style="margin-bottom: 0.8em;">
                <h4 class="is-marginless">
                  {{ unit.name }}
                </h4>
                <div class="flex-row">
                  <el-tooltip
                    :content="unit.labels.enabled ? $t('chart.yAxis.hide') : $t('chart.yAxis.show')"
                    placement="top"
                  >
                    <el-button
                      @click="unit.labels.enabled = !unit.labels.enabled"
                      type="primary"
                      size="mini"
                    >
                      <font-awesome-icon v-if="unit.labels.enabled" icon="eye-slash" />
                      <font-awesome-icon v-if="!unit.labels.enabled" icon="eye" />
                    </el-button>
                  </el-tooltip>
                  <el-tooltip :content="$t('chart.yAxis.position')" placement="top">
                    <el-button
                      :disabled="!unit.labels.enabled"
                      @click="unit.opposite = changeLabelSide(unit.opposite)"
                      type="primary"
                      size="mini"
                    >
                      <font-awesome-icon icon="redo" />
                    </el-button>
                  </el-tooltip>
                  <el-tooltip :content="$t('chart.yAxis.save')" placement="top">
                    <el-button
                      @click="saveScale(index)"
                      type="primary"
                      size="mini"
                    >
                      <font-awesome-icon icon="save" />
                    </el-button>
                  </el-tooltip>
                  <el-tooltip :content="$t('chart.yAxis.load')" placement="top">
                    <el-button
                      @click="loadScale(index)"
                      type="primary"
                      size="mini"
                    >
                      <font-awesome-icon icon="arrow-circle-down" />
                    </el-button>
                  </el-tooltip>
                </div>
              </div>
            </div>
            <div class="flex-row wrap">
              <div class="flex-column" style="padding:5px;">
                <label class="label">{{ $t('chart.yAxis.min') }}</label>
                <el-input-number v-model="unit.min" :precision="2" size="medium" @change="handleOptionChange();" />
              </div>
              <div class="flex-column" style="padding:5px;">
                <label class="label">{{ $t('chart.yAxis.max') }}</label>
                <el-input-number v-model="unit.max" :precision="2" size="medium" @change="handleOptionChange();" />
              </div>
              <div class="flex-column" style="padding:5px;">
                <label class="label">{{ $t('chart.yAxis.interval') }}</label>
                <el-input-number
                  v-model="unit.tickInterval"
                  :precision="3"
                  :min="0.001"
                  size="medium"
                  @change="handleOptionChange();"
                />
              </div>
              <template v-if="unit.instrument_type && unit.instrument_type.type === 'rainGauge'">
                <div class="flex-column" style="padding:5px;">
                  <label class="label">{{ $t('chart.date.hour') }}</label>
                  <el-input-number
                    v-model="rainOption[`${unit.instrument_type.defaultHourInterval}:${unit.instrument_type.defaultMinuteInterval}`].hourInterval"
                    size="medium"
                    :min="0"
                    :max="24"
                    :step="unit.instrument_type.hourIntervalStep || 1"
                    :step-strictly="true"
                    :placeholder="$t('chart.date.hour')"
                    @change="rescaleChart"
                  />
                </div>
                <div class="flex-column" style="padding:5px;">
                  <label class="label">{{ $t('chart.date.minute') }}</label>
                  <el-input-number
                    v-model="rainOption[`${unit.instrument_type.defaultHourInterval}:${unit.instrument_type.defaultMinuteInterval}`].minuteInterval"
                    :min="0"
                    :max="60"
                    :step="unit.instrument_type.minuteIntervalStep || 1"
                    :step-strictly="true"
                    :placeholder="$t('chart.date.minute')"
                    @change="rescaleChart"
                    size="medium"
                  />
                </div>
              </template>
              
              <div class="flex-column" style="padding:5px;">
                <label class="label">{{ $t('chart.yAxis.endOnTick') }}</label>
                <el-switch
                  v-model="unit.endOnTick"
                  @change="handleChange"
                >
                </el-switch>
              </div>
            </div>
            <div class="flex-row">
              <div class="flex-column">
                {{ $t('chart.info.yAxisTitle') }}
                <el-input
                  :placeholder="$t('chart.userSetting.yAxisTitle')"
                  size="large"
                  v-model="unit.yAxisTitle"
                  @input="submityAxisTitleChange(index)"
                ></el-input>
              </div>
            </div>
          </el-card>
        </div>
        <el-form
          :model="customize"
          label-position="left"     
          label-width="120px"     
          size="large"    
        >
          <!-- 圖表標題 -->
          <el-form-item :label="$t('chart.info.chartTitle')">
            <el-input
              v-model="customize.chartTitle"
              :placeholder="$t('chart.userSetting.chartTitle')"
              @input="submitChartTitleChange"
            />
          </el-form-item>
        
          <!-- X 軸 -->
          <el-form-item :label="$t('chart.info.xAxisTitle')">
            <el-input
              v-model="customize.xAxisTitle"
              :placeholder="$t('chart.userSetting.xAxisTitle')"
              @input="submitxAxisTitleChange"
            />
          </el-form-item>
        </el-form>
      </div>
    </el-drawer>

    <el-card v-if="showTable">
      <el-button type="primary" @click="exportToExcel">Export to Excel</el-button>
      <el-button type="primary" @click="exportToDocx" style="margin-left: 8px;">Export to DOCX</el-button>
      <hot-table :settings="hotSettings" ref="hot" style="margin-top: 12px"></hot-table>
    </el-card>
  </div>
</template>

<script>
import moment from 'moment';
import MomentTimeZone from 'moment-timezone';
import { chartColorPalettes, GRID_LINE_COLOR_LIST, TOP_GRID_LINE_COLOR } from './chartColorPalettes.js';
import { symbols } from './symbol.js';
import { getStatusColor } from '@/lib/base/systemAlert.js';
import RemarkForm from '@/components/remark/CreateForm.vue';
import { HotTable } from '@handsontable/vue';
import * as XLSX from 'xlsx';
import { clientVersion } from '../../constants/env';
import { roundTo } from '@/utils/formatters';
import 'highcharts/css/highcharts.css';
import {
  Document,
  Packer,
  Paragraph,
  TextRun,
  HeadingLevel,
  AlignmentType,
  ImageRun,
  Table,
  TableRow,
  TableCell,
  WidthType,
  PageOrientation,
  VerticalAlign, 
  BorderStyle,
} from 'docx';

MomentTimeZone();
export default {
  name: 'ChartComponents',
  components: {
    RemarkForm,
    HotTable,
  },
  props: {
    hadSubmitted:{
      required: true,
      type: Boolean,
    },
    dataLoading:{
      required: true,
      type: Boolean,
    },
    selectedInstrument:{
      require: true,
    },
    chartData:{
      require: true,
    },
    instrumentRemarkList: {
      default: true,
    },
    groupName:{
      require: true,
      type: String,
    },
    groupOption:{
      require: true,
    },
    rainOption:{
      default: {},
    },
    date: {
      type: Date,
    },
    yAxisFixed: {
      // 外部只會傳 { min: 20, max: 40, tickInterval: 2 }
      type: Object,
      default: null,
    },
    yAxisFixedMap: {
      type: Object,
      default: null,
    },
    interactive: {
      type: Boolean,
      default: true,
    },
    fixedRainColor: {
      type: Boolean,
      default: false,
    },
  },
  data(){
    return {
      project: null,
      autoRefresh: false,
      showRemark: true,
      showSettings: false,
      showTable: false,
      hotSettings: {
        data: [],
        colHeaders: [],
        licenseKey: 'non-commercial-and-evaluation',
        colWidths: 200,
        height: 400,
        autoColumnSize: true,
        readOnly: true,
      },
      alertInstrument: {
        _id: null,
        showTarget: ['WSL', 'AL'],
      },
      remark: {
        formType: 'create',
        editing: {},
        instrument: '',
        timestamp: '',
        show: false,
      },
      lastRefreshTimestamp: 0,
      refreshFunction: '',
      chartLoading: true,
      chartReady: false,
      chartDateRangeList: [
        {
          name: '6H',
          day: null,
          hours: 6,
        },
        {
          name: '1D',
          day: 1,
          hours: null,
        },
        {
          name: '7D',
          day: 7,
          hours: null,
        },
      ],
      chartActiveIndex: 1,
      colorPalettes: chartColorPalettes,
      customize: {
        xAxisTickInterval: {
          day: 1,
          hours: null,
        },
        chartTitle: undefined,
        xAxisTitle: undefined,
      },
      options: {
        series: [],
        xAxis: {
          min: undefined,
          max: undefined,
          type: 'datetime',
        },
        yAxis: [],
      },
      oldYAxis: [],
      unitIndex: [],
      showVelocity1Hr: false,
      showVelocity24Hr: false,
      enable1HrVelocity: false,
      enable24HrVelocity: false,

      enableRain1Day: false,
      //目前的功能是數值等同於isUpdate，
      //若數值為true(isUpdate=true)，則使用警戒值作為生成上下限的參考，
      //若數值為false(isUpdate=false)，則僅使用自身作為上下限的參考
      rescaleChartStateMachine: true, 
      //rainOption: {},
      enableTrendline: false,
      //userExtremesFlag: false,

      userYAxisOptions: {},
      optionChange: false,
    };
  },
  computed:{
    selectedProject() {
      if(this.project) return this.project;
      return this.$store.getters['project/selectedProject'];
    },
    hasAccess() {
      return {
        remark: this.$store.getters['project/hasRemarkAccess'],
      };
    },
    loading() {
      return this.dataLoading || this.chartLoading;
    },
    chartOptions() {
      const vm = this;
      const interactive = this.interactive !== false;
      const series = this.$lodash.cloneDeep(this.options.series);
      if (this.enableTrendline) {
        for (let serie of this.options.series) {
          if (serie.type != 'line') continue;
          const { slope, intercept, startX } = this.calculateLinearRegression(serie.data);
          console.log(`StartX: ${startX}`);
          const slopePerDay = slope * 86400000;
          const slopeText = `${slopePerDay.toFixed(4)} ${serie.unit}/天`;

          const sign = intercept >= 0 ? '+' : '-';
          const absIntercept = Math.abs(intercept).toFixed(3);
          const formulaText = `y = (${slopeText})x ${sign} ${absIntercept} ${serie.unit}`;

          series.push({
            type: 'trendline',
            linkedTo: serie.id,
            showInLegend: true, 
            name: `趨勢線 ${formulaText}`, 
            unit: serie.unit,
            tooltip: {
              valueSuffix: ` ${serie.unit}`,
            },
          });
        }
      }

      let yAxis = vm.options.yAxis;
      if(yAxis.length > 0) {
        yAxis[yAxis.length-1].gridLineColor = TOP_GRID_LINE_COLOR;
        yAxis[yAxis.length-1].className = 'highcharts-grid-top';
        //if(this.customize.yAxisTitle) yAxis[0].title.text = this.customize.yAxisTitle;
      }

      return {
        title: {
          text: this.customize.chartTitle ?? this.$t('chart.title.historyChart'),
        },
        exporting: {
          enabled: false,
        //  scale: 3,
        //  allowHTML: false, // 禁用內聯樣式
        //  // sourceWidth: 1200
        //},
        //boost: {
        //  useGPUTranslations: true,
        },
        time: {
          timezone: this.timezone,
        },
        chart: {
          zoomType: interactive ? 'xy' : null,
          height: 500,
          spacingLeft: 50,
          spacingRight: 30,
          styledMode: !this.fixedRainColor,
        },
        credits: {
          enabled: false,
        },
        plotOptions: {
          series: {
            animation: interactive ? { duration: 500 } : false,
            turboThreshold: 0,
            cursor: interactive ? 'pointer' : 'default',
            enableMouseTracking: interactive,
            states: {
              hover: { enabled: interactive },
              inactive: { opacity: interactive ? 0.2 : 1 },
            },
            point: {
              events: {
                click(event) {
                  if (!vm.interactive) return;
                  console.log('click');
                  if (vm.hasAccess.remark) {
                    vm.remark.instrument = event.point.instrument;
                    vm.remark.timestamp = event.point.x;
                    if (event.point.remark) {
                      const remark = event.point.remark;
                      vm.remark.formType = 'edit';
                      vm.remark.editing = remark;
                    } else {
                      vm.remark.formType = 'create';
                    }
                    vm.remark.show = true;
                  }
                },
              },
            },
            scatter: interactive
              ? {
                tooltip: {
                  dateTimeLabelFormats: '%Y/%m/%d %H:%M',
                },
              }
              : {
                tooltip: { enabled: false },
              },
          },
          scatter: {
            showInLegend: false,
            enableMouseTracking: interactive,
            states: {
              hover: { enabled: interactive },
            },
            tooltip: interactive
              ? {
                crosshairs: true,
                xDateFormat: '%Y/%m/%d %H:%M',
              }
              : { enabled: false },
          },
        },
        tooltip: interactive
          ? {
            // useHTML: true,
            xDateFormat: '%Y/%m/%d %H:%M',
            valueDecimals: 3,
            shared: !this.kmrtRole,
            className: 'tooltip-box',
            formatter(tooltip) {
              const symbolMap = {
                'square': '■',
                'diamond': '♦',
                'triangle': '▲',
                'triangle-down': '▼',
                'circle': '●',
              };

              const pointsList = this.points || [this];

              if (!vm.showRemark) {
                let defaultTooltip = tooltip.defaultFormatter.call(this, tooltip);
                
                if (Array.isArray(defaultTooltip)) {
                  pointsList.forEach((pt, index) => {
                    if (defaultTooltip[index + 1]) {
                      const seriesSymbol = pt.series.symbol;
                      const targetSymbol = symbolMap[seriesSymbol];
                      if (targetSymbol) {
                        defaultTooltip[index + 1] = defaultTooltip[index + 1].replace('●', targetSymbol);
                      }
                    }
                  });
                }

                return defaultTooltip;
              }
              
              const remarks = pointsList
                .map(ele => {
                  const pt = ele.point || (ele.series ? ele : null);
                  if (pt && pt.remark) {
                    return {
                      content: pt.remark.content,
                      color: pt.color || (pt.series ? pt.series.color : '#000'),
                    };
                  }
                })
                .filter(ele => ele !== undefined);

              let defaultTooltip = tooltip.defaultFormatter.call(this, tooltip);

              pointsList.forEach((pt, index) => {
                if (defaultTooltip[index + 1]) {
                  const seriesSymbol = pt.series.symbol;
                  const targetSymbol = symbolMap[seriesSymbol];
                  if (targetSymbol) {
                    defaultTooltip[index + 1] = defaultTooltip[index + 1].replace('●', targetSymbol);
                  }
                }
              });

              if (remarks.length > 0) {
                remarks.forEach((remark, index) => {
                  if (index === 0) {
                    const gap = '<span style="margin-top:8px"></span></br>';
                    defaultTooltip.push(gap);
                  }
                  const remarkHtml = `<span style="color:${remark.color}">▲</span><span style="font-weight:bold; font-size:14px"> ${remark.content}</span><br/>`;
                  defaultTooltip.push(remarkHtml);
                });
              }
              
              return defaultTooltip;
            },
          }
          : { enabled: false },
        yAxis,
        xAxis: {
          ...vm.options.xAxis,
          min: this.$moment(this.date[0]).valueOf(),
          startOnTick: true,
          title: {
            text: this.customize.xAxisTitle ?? 'Date',
            align: 'low',
          },
          endOnTick: true,
          showFirstLabel: true,
          gridLineWidth: 1,
          labels: {
            style: {
              fontWeight: 700,
              fontSize: '13px',
            },
            formatter() {
              // if (this.isFirst || this.isLast) {
              if (this.isFirst) {
                const timestamp = vm.$moment(this.value);
                const hour = timestamp.hour();
                const minute = timestamp.minute();
                if (hour === 0 && minute === 0) {
                  return vm.$moment(this.value).format('YYYY/MM/DD');
                } else {
                  return vm.$moment(this.value).format('YYYY/MM/DD HH:mm');
                }
              } else {
                return this.axis.defaultLabelFormatter.call(this);
              }
            },
          },
          dateTimeLabelFormats: {
            millisecond: '%m/%d %H:%M',
            second: '%m/%d %H:%M',
            minute: '%m/%d %H:%M',
            hour: '%m/%d %H:%M',
            day: '%m/%d',
            week: '%m/%d',
            month: '%m/%d',
            year: '%m/%d',
          },
          tickInterval: (() => {
            const userInterval = (this.customize.xAxisTickInterval.day * 24 + this.customize.xAxisTickInterval.hours) * 3600 * 1000;

            if (!userInterval || userInterval <= 0) return null;

            let maxTimestamp = 0;
            let minTimestamp = this.$moment(this.date[0]).valueOf();

            if (series && series.length > 0) {
              series.forEach(s => {
                if (s.data && s.data.length > 0) {
                  const lastPoint = s.data[s.data.length - 1];
                  if (lastPoint.x > maxTimestamp) maxTimestamp = lastPoint.x;
                }
              });
            }

            if (maxTimestamp === 0) return userInterval;

            const duration = maxTimestamp - minTimestamp;

            const estimatedTicks = duration / userInterval;

            const MAX_TICKS = 200; 

            if (estimatedTicks > MAX_TICKS) {
              return null; 
              // return userInterval * Math.ceil(estimatedTicks / MAX_TICKS);
            }
            return userInterval;
          })(),
        },
        series,
        legend: {
          maxHeight: 80,
          symbolWidth: 1,
          labelFormatter() {
            const map = { WL: '注意值', AL: '警戒值', WSL: '行動值' };
            return map[this.name] || this.name;
          },
        },
      };
    },
    timezone() {
      return this.$store.getters['env/timezone'];
    },
    testRole() {
      return clientVersion === 'test';
    },
    kmrtRole() {
      return clientVersion === 'kmrt';
    },
  },
  mounted(){
    this.checkProjectVelocityOption();
    this.update('yAxisRule_optionPrecedeRescale');
  },
  watch: {
    selectedInstrument: {
      handler(newValue, oldValue) {
        if (newValue.length !== oldValue.length) {
          this.updateChartData();
        }
      },
      deep: true,
    },
  },
  beforeDestroy() {
    if (this.refreshFunction) {
      clearInterval(this.refreshFunction);
    }
  },
  methods: {
    processGaps(data, maxGapMs = 604800000) { // 1d=86400000 1hr=3600000 7d=604800000
      const isInvalid = y => y === null || y === undefined || typeof y !== 'number' || isNaN(y);
      const result = [];
      let i = 0;
      let runCount = 0;
      console.log(`[processGaps] 輸入筆數: ${data.length}, maxGapMs: ${maxGapMs}`);
      while (i < data.length) {
        if (!isInvalid(data[i].y)) {
          result.push(data[i]);
          i++;
        } else {
          const runStart = i;
          while (i < data.length && isInvalid(data[i].y)) i++;
          const runEnd = i - 1;
          const span = data[runEnd].x - data[runStart].x;
          runCount++;
          console.log(
            `[processGaps] 無效區間#${runCount}:`,
            new Date(data[runStart].x).toLocaleString(), '~', new Date(data[runEnd].x).toLocaleString(),
            `| span=${span}ms (${(span / 3600000).toFixed(2)}h)`,
            `| 點數=${runEnd - runStart + 1}`,
            `| 結果: ${span > maxGapMs ? '斷線(保留null)' : '連線(移除)'}`,
          );
          if (span > maxGapMs) {
            result.push({ x: data[runStart].x, y: null });
          }
        }
      }
      console.log(`[processGaps] 輸出筆數: ${result.length} (移除了 ${data.length - result.length} 筆無效點), 共 ${runCount} 段無效區間`);
      return result;
    },
    calculateLinearRegression(data) {
      let n = data.length;
      if (n === 0) return { slope: 0, intercept: 0 };

      let sumX = 0;
      let sumY = 0;
      let sumXY = 0;
      let sumXX = 0;

      let startX = 0;
      if (n > 0) {
        if (Array.isArray(data[0])) {
          startX = data[0][0];
        } else {
          startX = data[0].x;
        }
      }

      for (let i = 0; i < n; i++) {
        let x, y;
        if (Array.isArray(data[i])) {
          x = data[i][0];
          y = data[i][1];
        } else {
          x = data[i].x;
          y = data[i].y;
        }

        let relativeX = x - startX;

        sumX += relativeX;
        sumY += y;
        sumXY += (relativeX * y);
        sumXX += (relativeX * relativeX);
      }

      const slope = (n * sumXY - sumX * sumY) / (n * sumXX - sumX * sumX);
      const intercept = (sumY - slope * sumX) / n;

      return { slope, intercept, startX };
    },
    updateChartData() {
      this.generateSeries();
      //this.generateYAxis(true);
      //this.rescaleChart();
    },
    updatetableData() {
      if (this.showTable) {
        let colHeaders = ['Date'];
        let allDates = new Set();
        let dataMap = {};

        // 日期和初始化數據映射
        this.options.series.forEach(inst => {
          //console.log(inst);
          if (!inst.name.includes('WL') && !inst.name.includes('AL') && !inst.name.includes('WSL') && !dataMap[inst.name]) {
            colHeaders.push(inst.name);
            dataMap[inst.name] = {};

            if (inst.data.length) {
              inst.data.forEach(item => {
                let date = new Date(item.x);
                let formattedDate = date.getFullYear() + '-' +
                  ('0' + (date.getMonth() + 1)).slice(-2) + '-' +
                  ('0' + date.getDate()).slice(-2) + ' ' +
                  ('0' + date.getHours()).slice(-2) + ':' +
                  ('0' + date.getMinutes()).slice(-2) + ':' +
                  ('0' + date.getSeconds()).slice(-2);
                allDates.add(formattedDate);
                dataMap[inst.name][formattedDate] = item.y;
              });
            }
          }
        });

        let sortedDates = Array.from(allDates).sort();

        // 對於每個日期檢查每個儀器是否有數據
        let data = sortedDates.map(date => {
          return colHeaders.slice(1).map(header => dataMap[header][date] ?? '');
        });

        // 將日期列加到數據陣列的開頭
        data = sortedDates.map((date, index) => [date, ...data[index]]);

        this.hotSettings = {
          ...this.hotSettings,
          colHeaders,
          data,
        };
        this.updateTable();
      }
    },
    toggleShowTable(event) {
      this.showTable = !this.showTable;
      let target = event.currentTarget;
      if (target) {
        target.blur();
      }
      this.updatetableData();
    },
    exportToExcel() {
      let data = this.hotSettings.data;
      let colHeaders = this.hotSettings.colHeaders;

      data = [colHeaders].concat(data);
      let currentDate = new Date().toISOString().slice(0,10).replace(/-/g, '');

      let filename = '';
      if (colHeaders.length === 2) {
        filename = `export_${colHeaders[1]}_${currentDate}.xlsx`;
      } else {
        filename = `export_${currentDate}.xlsx`;
      }

      const worksheet = XLSX.utils.aoa_to_sheet(data);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');

      XLSX.writeFile(workbook, filename);
    },
    _wrapHeaderIntoTwoLines(h, maxCharsPerLine = 12) {
      if (!h) return [''];
      const parts = String(h).split(/[-\s_]+/).filter(Boolean);
      // 先用語義片段湊兩行
      const lines = ['', ''];
      for (const p of parts) {
        if ((lines[0] + (lines[0] ? ' ' : '') + p).length <= maxCharsPerLine) {
          lines[0] += (lines[0] ? ' ' : '') + p;
        } else if ((lines[1] + (lines[1] ? ' ' : '') + p).length <= maxCharsPerLine) {
          lines[1] += (lines[1] ? ' ' : '') + p;
        } else {
          // 第二行放不下，就截斷加省略
          if (!lines[1]) {
            lines[1] = p.slice(0, Math.max(3, maxCharsPerLine - 1)) + '…';
          } else if (!lines[1].endsWith('…')) {
            lines[1] = lines[1].slice(0, Math.max(3, maxCharsPerLine - 1)) + '…';
          }
          break;
        }
      }
      // 若第一輪拆不出第二行，但原字串仍太長，做硬切
      if (!lines[1] && String(h).length > maxCharsPerLine) {
        lines[0] = String(h).slice(0, maxCharsPerLine);
        lines[1] = String(h).slice(maxCharsPerLine, maxCharsPerLine * 2);
        if (String(h).length > maxCharsPerLine * 2) lines[1] = lines[1].slice(0, maxCharsPerLine - 1) + '…';
      }
      return [lines[0] || String(h), lines[1] || ''];
    },

    // 將欄位切成多個表：每張表最多 10 欄（包含 Date）
    _splitColumns(colHeaders, dataRows, maxColsPerTable = 10) {
      const dateCol = colHeaders[0];
      const others = colHeaders.slice(1);
      const groupSize = Math.max(1, maxColsPerTable - 1); // 扣掉 Date
      const groups = [];
      for (let i = 0; i < others.length; i += groupSize) {
        const cols = [dateCol, ...others.slice(i, i + groupSize)];
        const idxMap = cols.map(c => colHeaders.indexOf(c));
        const rows = dataRows.map(r => idxMap.map(ix => r[ix]));
        groups.push({ headers: cols, rows });
      }
      // 若原本就只有 Date 一欄，也需至少產一張表
      if (!groups.length) groups.push({ headers: [dateCol], rows: dataRows.map(r => [r[0]]) });
      return groups;
    },

    async exportToDocx() {
      try {
        let colHeaders = Array.isArray(this.hotSettings.colHeaders) ? this.hotSettings.colHeaders : [];
        let dataRows = Array.isArray(this.hotSettings.data) ? this.hotSettings.data : [];

        if (!colHeaders.length) {
          this.$notifyError?.(this.$t?.('Notify.error') || 'Error', '目前沒有可輸出的欄位。');
          return;
        }

        // 切成多張表（每張最多 10 欄，包含 Date）
        const groups = this._splitColumns(colHeaders, dataRows, 14);

        // 公用：建 cell
        const makeHeaderCell = (text) => {
          const [l1, l2] = this._wrapHeaderIntoTwoLines(text, 12); // 每行大約 12 字
          const runs = [
            new TextRun({ text: l1, bold: true, font: 'Microsoft JhengHei', size: 12 }),
            ...(l2 ? [new TextRun({ break: 1 }), new TextRun({ text: l2, bold: true, font: 'Microsoft JhengHei', size: 12 })] : []),
          ];
          return new TableCell({
            verticalAlign: VerticalAlign.CENTER,
            borders: {
              top: { style: BorderStyle.SINGLE, size: 4, color: '888888' },
              bottom: { style: BorderStyle.SINGLE, size: 4, color: '888888' },
              left: { style: BorderStyle.SINGLE, size: 4, color: '888888' },
              right: { style: BorderStyle.SINGLE, size: 4, color: '888888' },
            },
            shading: { type: 'clear', color: 'auto', fill: 'D9D9D9' },
            children: [
              new Paragraph({
                alignment: AlignmentType.CENTER,
                children: runs,
              }),
            ],
            margins: { top: 100, bottom: 100, left: 100, right: 100 },
          });
        };

        const makeBodyCell = (text, align = AlignmentType.LEFT) =>
          new TableCell({
            verticalAlign: VerticalAlign.CENTER,
            borders: {
              top: { style: BorderStyle.SINGLE, size: 4, color: 'AAAAAA' },
              bottom: { style: BorderStyle.SINGLE, size: 4, color: 'AAAAAA' },
              left: { style: BorderStyle.SINGLE, size: 4, color: 'AAAAAA' },
              right: { style: BorderStyle.SINGLE, size: 4, color: 'AAAAAA' },
            },
            children: [
              new Paragraph({
                alignment: align,
                children: [
                  new TextRun({ text: (text ?? '').toString(), font: 'Microsoft JhengHei', size: 12 }),
                ],
              }),
            ],
            margins: { top: 100, bottom: 100, left: 100, right: 100 },
          });

        const children = [];
        
        groups.forEach((g, gi) => {
          const colCount = g.headers.length;
          const widthPerCol = Math.floor(100 / colCount); // 平均欄寬（%）

          const headerRow = new TableRow({
            // 避免跨頁拆列
            cantSplit: true,
            children: g.headers.map(h => {
              const cell = makeHeaderCell(h);
              cell.width = { size: widthPerCol, type: WidthType.PERCENTAGE };
              return cell;
            }),
          });

          const bodyRows = g.rows.map(row => new TableRow({
            cantSplit: true,
            children: row.map((cell, ci) => {
              const align = ci === 0 ? AlignmentType.CENTER : AlignmentType.RIGHT;
              let display = cell;
              if (ci === 0) {
                const s = (cell ?? '').toString();
                display = (s.match(/\d{4}-\d{2}-\d{2}/)?.[0]) || s.slice(0, 10);
              }
              const td = makeBodyCell(display, align);
              td.width = { size: widthPerCol, type: WidthType.PERCENTAGE };
              return td;
            }),
          }));

          const table = new Table({
            width: { size: 100, type: WidthType.PERCENTAGE },
            rows: [headerRow, ...bodyRows],
          });
          children.push(table);
          // 兩張表之間放一個很小的空段落，不換頁
          if (gi !== groups.length - 1) {
            children.push(new Paragraph({ text: '', spacing: { before: 60, after: 60 }, keepNext: true }));
          }
        });

        // 只建立「一個」 section，所有表格都在裡面
        const sections = [{
          properties: {
            page: {
              size:   { orientation: PageOrientation.LANDSCAPE },
              margin: { top: 720, bottom: 720, left: 720, right: 720 },
            },
          },
          children,
        }];

        const doc = new Document({ sections });
        const blob = await Packer.toBlob(doc);

        const currentDate = new Date().toISOString().slice(0, 10).replace(/-/g, '');
        const base =
          colHeaders.length === 2 ? `export_${colHeaders[1]}` : 'export';
        const filename = `${base}_${currentDate}.docx`;

        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = filename;
        document.body.appendChild(a);
        a.click();
        a.remove();
        URL.revokeObjectURL(url);

        this.$notifySuccess?.('Success', 'DOCX 匯出完成');
      } catch (err) {
        console.error(err);
        this.$notifyError?.('Error', 'DOCX 匯出失敗');
      }
    },
    applyFixedYAxisFromProp() {
      if (!this.options || !Array.isArray(this.options.yAxis) || !this.options.yAxis.length) return;
      const defaultFixed = this.yAxisFixed;
      const map = this.yAxisFixedMap && typeof this.yAxisFixedMap === 'object' ? this.yAxisFixedMap : null;
      const mapKeys = map ? Object.keys(map) : [];
      if (!this.userYAxisOptions || typeof this.userYAxisOptions !== 'object') this.userYAxisOptions = {};
      this.options.yAxis.forEach((axis, index) => {
        if (!axis) return;
        const candidates = [];
        if (axis.name != null) candidates.push(String(axis.name));
        const titleText = axis.title && axis.title.text ? String(axis.title.text) : '';
        if (titleText) candidates.push(titleText);
        let fixed = null;
        if (mapKeys.length) {
          for (const key of mapKeys) {
            if (candidates.some(candidate => candidate && candidate.indexOf(key) !== -1)) {
              fixed = map[key];
              break;
            }
          }
        }
        if (!fixed && defaultFixed) fixed = defaultFixed;
        if (!fixed) return;
        const applyMin = fixed.min !== undefined ? fixed.min : fixed.minimum;
        const applyMax = fixed.max !== undefined ? fixed.max : fixed.maximum;
        const applyTick = fixed.tickInterval !== undefined ? fixed.tickInterval : fixed.interval;
        const unitKey = axis.name != null ? String(axis.name) : (candidates.find(Boolean) || ('axis-' + (axis.id != null ? axis.id : index)));
        if (!this.userYAxisOptions[unitKey]) this.userYAxisOptions[unitKey] = {};
        const target = this.userYAxisOptions[unitKey];
        if (applyMin !== undefined) { target.min = applyMin; axis.min = applyMin; }
        if (applyMax !== undefined) { target.max = applyMax; axis.max = applyMax; }
        if (applyTick !== undefined) { target.tickInterval = applyTick; axis.tickInterval = applyTick; }
        target.startOnTick = true;
        target.endOnTick = false;
        if (!this.userYAxisOptions[index]) this.userYAxisOptions[index] = {};
        Object.assign(this.userYAxisOptions[index], target);
        axis.startOnTick = true;
        axis.endOnTick = false;
        if (this.cloneOptions && this.cloneOptions.yAxis && this.cloneOptions.yAxis[index]) {
          const cloneAxis = this.cloneOptions.yAxis[index];
          if (applyMin !== undefined) cloneAxis.min = applyMin;
          if (applyMax !== undefined) cloneAxis.max = applyMax;
          if (applyTick !== undefined) cloneAxis.tickInterval = applyTick;
          cloneAxis.startOnTick = true;
          cloneAxis.endOnTick = false;
        }
      });
    },
    setOption(){
      //console.log(this.groupOption);
      if(this.groupOption!={}){
        this.showVelocity1Hr = this.groupOption.showVelocity1Hr;
        this.showVelocity24Hr = this.groupOption.showVelocity24Hr;
      }
    },
    update(type = 'yAxisRule_beAsIs'){
      this.setOption();
      this.chartReady = false;
      this.chartLoading = true;
      if(this.hadSubmitted && !this.dataLoading){
        if([NaN,undefined,null].includes(this.selectedInstrument[0])) return;
        this.alertInstrument._id = this.selectedInstrument[0]._id;
        this.rescaleChart(type);
      }
    },
    rescaleChart(type = 'yAxisRule_beAsIs') {
      return this.generateYAxis(true)
        .then(() => {
          return this.generateSeries();
        })
        .then(() => {
          this.applyFixedYAxisFromProp();
          this.getAxisData(type);
        });
    },
    rescaleChartBtn(type = 'yAxisRule_beAsIs'){
      if(type == 'yAxisRule_rescale') this.rescaleChartStateMachine = !this.rescaleChartStateMachine;
      this.oldYAxis = [];
      return this.generateYAxis(true)
        .then(() => {
          this.applyFixedYAxisFromProp();
          this.generateSeries();
        })
        .then(() => {
          this.getAxisData(type);
        });
    },
    checkProjectVelocityOption(){
      //const showList = this.selectedProject.config.data.display;
      //if(showList.includes('velocity1Hr')) this.enable1HrVelocity = true;
      //if(showList.includes('velocity24Hr')) this.enable24HrVelocity = true;
      this.enable1HrVelocity = false;
      this.enable24HrVelocity = false;
      const instrumentList = this.selectedInstrument;
      instrumentList.forEach(ins=>{
        if(ins.latestVersion.allowRate) {
          this.enable1HrVelocity = true;
          this.enable24HrVelocity = true;
        }
      });
      if(!this.enable1HrVelocity) this.showVelocity1Hr = false;
      if(!this.enable24HrVelocity) this.showVelocity24Hr = false;
    },
    updateYAxis() {
      this.generateYAxis(true).then(() => {
        this.getAxisData('yAxisRule_optionPrecedeAlert').then(()=>{
          this.handleChange();
        });
      });
    },
    generateYAxis(isUpdate = false) {
      return new Promise(resolve => {
        this.unitIndex = [];
        const unitList = this.selectedInstrument.map(ele => ele.latestVersion.unit);
        const indexList = [];
        unitList.forEach((unit, index) => {
          if (unitList.indexOf(unit) === index) {
            indexList.push(index);
          }
        });
        this.options.yAxis = this.selectedInstrument
          .map((ele, index) => {
            const showUnit = indexList.includes(index);
            if (!showUnit) return;
            const ref = ele.latestVersion;
            let obj = {};
            if (!isUpdate) {
              obj = this.oldYAxis.find(old => old.name === ref.unit);
            }
            let unitFormat = ref.unit;
            if (ele.instrument_type && ele.instrument_type.type === 'rainGauge') {
              let rainOption = this.rainOption[`${ele.instrument_type.defaultHourInterval}:${ele.instrument_type.defaultMinuteInterval}`];
              unitFormat = `${ele.instrument_type.unit}/`;
              let hourInterval = rainOption.hourInterval;
              let minuteInterval = rainOption.minuteInterval;
              if(this.enableRain1Day){
                unitFormat = `${ele.instrument_type.unit}/${this.$i18n.t('chart.day')}`;
              } else if (hourInterval > 0 && minuteInterval > 0) {
                unitFormat = `${ele.instrument_type.unit}/${hourInterval}H ${minuteInterval}M`;
              } else if (hourInterval > 0) {
                unitFormat = `${ele.instrument_type.unit}/${hourInterval}H`;
              } else if (minuteInterval > 0) {
                unitFormat = `${ele.instrument_type.unit}/${minuteInterval}M`;
              }
            }
            if(this.showVelocity1Hr && ele.latestVersion.allowRate) unitFormat = `${unitFormat}/1Hr`;
            if(this.showVelocity24Hr && ele.latestVersion.allowRate) unitFormat = `${unitFormat}/24Hr`;
            let format = `{value}${unitFormat}`;
            const instrument = this.selectedInstrument.find(
              instrument => instrument._id === this.alertInstrument._id,
            );
            if (this.$lodash.isEmpty(obj)) {
              let plotLines = [];

              if (ele._id === this.alertInstrument._id) {
                this.alertInstrument.showTarget.forEach(target => {
                  if(instrument){
                    const plus_value = this.getAlertValue(`${target}_plus`, instrument);
                    const minus_value = this.getAlertValue(`${target}_minus`, instrument);
                    if (![null, undefined].includes(plus_value)) {
                      plotLines.push({
                        color: getStatusColor(target),
                        width: 2,
                        value: plus_value,
                        className: this.getStatusClassName(target),
                      });
                    }
                    if(![null, undefined].includes(minus_value)) {
                      plotLines.push({
                        color: getStatusColor(target),
                        width: 2,
                        value: minus_value,
                        className: this.getStatusClassName(target),
                      });
                    }
                  }
                });
                console.log(this.alertInstrument);
                console.log(instrument);
              }
              const oldYAxis = this.oldYAxis.find(ele => ele.name === unitFormat);

              obj = {
                name: unitFormat,
                instrument_name: ref.name,
                instrument_type: ele.instrument_type,
                title: {
                  align: 'high',
                  offset: 0,
                  text: this.$t('chart.measurements'),
                  rotation: 0,
                  y: -10,
                },
                labels: {
                  enabled: showUnit,
                  format,
                  style: {
                    fontWeight: 700,
                    fontSize: '13px',
                  },
                },
                opposite: this.unitIndex.length % 2,
                tickInterval: oldYAxis ? oldYAxis.tickInterval : undefined,
                plotLines,
                max: oldYAxis ? oldYAxis.max : undefined,
                min: oldYAxis ? oldYAxis.min : undefined,
                startOnTick: false,
                endOnTick: false,
                gridLineColor: this.getGridLineColor(),
                className: this.getYGridClassName(),
                id: index,
              };
              if (ref.name.includes('RAIN') && this.fixedRainColor) {
                obj.gridLineColor = '#999999';
              }
            }
            const config = (this.showVelocity1Hr&&instrument.latestVersion.rate_1Hr_config) ? instrument.latestVersion.rate_1Hr_config : (this.showVelocity24Hr&&instrument.latestVersion.rate_24Hr_config) ? instrument.latestVersion.rate_24Hr_config : instrument.latestVersion;
            let useWSL = this.alertInstrument.showTarget.includes('WSL');
            let useAL = this.alertInstrument.showTarget.includes('AL');
            let useWL = this.alertInstrument.showTarget.includes('WL');
            let plus = (useWSL && config.WSL_plus) || (useAL && config.AL_plus) || (useWL && config.WL_plus);
            let minus = (useWSL && config.WSL_minus) || (useAL && config.AL_minus) || (useWL && config.WL_minus);
            this.unitIndex.push({
              unit: ref.unit,
              index: this.unitIndex.length,
              plus,
              minus,
            });
            return obj;
          })
          .filter(ele => ele);
        console.log('generateYAxis');
        console.log(this.unitIndex);
        resolve();
      });
    },
    generateSeries() {
      return new Promise(resolve => {
        this.options.series = this.selectedInstrument.map((instrument, index) => {
          const ref = instrument.latestVersion;
          const yAxisIndex = this.unitIndex.findIndex(record => {
            return record.unit === ref.unit;
          });

          const dataLength = this.chartData[ref.name].data.length;
          const data = [...this.chartData[ref.name].data];

          if (this.showRemark) {
            const remarkList = this.instrumentRemarkList.find(
              remark => remark.instrument_id === instrument._id,
            );
            //  find corresponding data from list and replace it with data wf remark
            if (remarkList) {
              remarkList.remark.forEach(remark => {
                const dataFitRemarkIndex = data.findIndex((ele, index) => {
                  if (moment(remark.start_date).isSame(ele.x)) {
                    return true;
                  } else if (index !== dataLength - 1) {
                    const nextEle = data[index + 1];
                    if (moment(remark.start_date).isBetween(ele.x, nextEle.x)) {
                      return true;
                    }
                  }
                });
                data[dataFitRemarkIndex] = {
                  ...data[dataFitRemarkIndex],
                  remark,
                  marker: {
                    enabled: true,
                    width: 20,
                    height: 20,
                    fillColor: '#FFFFFF',
                    symbol: `url(${symbols[remark.type]})`,
                    states: {
                      hover: {
                        enabled: true,
                        radiusPlus: 10,
                        lineWidthPlus: 5,
                      },
                    },
                  },
                };
              });
            }
          }

          let unitFormat = ref.unit;
          if (instrument.instrument_type && instrument.instrument_type.type === 'rainGauge') {
            let rainOption = this.rainOption[`${instrument.instrument_type.defaultHourInterval}:${instrument.instrument_type.defaultMinuteInterval}`];
            if(this.enableRain1Day){
              unitFormat = `${instrument.instrument_type.unit}/日`;
            } else if ( rainOption.hourInterval > 0 && rainOption.minuteInterval > 0 ) {
              unitFormat = `${instrument.instrument_type.unit}/${rainOption.hourInterval}H ${rainOption.minuteInterval}M`;
            } else if (rainOption.hourInterval > 0) {
              unitFormat = `${instrument.instrument_type.unit}/${rainOption.hourInterval}H`;
            } else if (rainOption.minuteInterval > 0) {
              unitFormat = `${instrument.instrument_type.unit}/${rainOption.minuteInterval}M`;
            }
          }
          if(this.showVelocity1Hr) unitFormat = `${unitFormat}/1Hr`;
          if(this.showVelocity24Hr) unitFormat = `${unitFormat}/24Hr`;
          const obj = {
            name: ref.name,
            data,
            unit: unitFormat,
            type: instrument.chart_type,
            instrument_type: instrument.instrument_type,
            yAxis: yAxisIndex,
            tooltip: {
              valueSuffix: ` ${unitFormat}`,
            },
            color: (this.fixedRainColor && ref.name.includes('RAIN')) ? '#999999' : this.colorPalettes[index],
            id: ref.name,
          };
          return obj;
        });

        this.options.series.forEach(series => {
          if (series.instrument_type && series.instrument_type.type === 'rainGauge') {
            const rainIns = this.selectedInstrument.find(i => i.latestVersion.name === series.id);
            const rainDecimals = rainIns?.latestVersion?.decimal_points || 4;
            // let instrumentInterval, lastN;
            if(this.enableRain1Day){
              let data = this.$lodash.cloneDeep(series.data);
              series.data = data.map((ele, index)=>{
                if (!this.$lodash.has(ele, 'originalY')) {
                  ele.originalY = ele.y;
                }
                let result = this.$lodash.cloneDeep(ele);
                if (index > 2) {
                  const totalData = this.accumulate1DayRainGaugeSum(
                    data,
                    index,
                    series.instrument_type.defaultInterval,
                  );

                  result.y = roundTo(totalData, rainDecimals);
                  result.x = result.x - 24 * 60 * 60 * 1000;
                }
                return result;
              }).filter((ele, index)=>{
                const time = new Date(ele.x);
                const hour = time.getHours();
                const minute = time.getMinutes();
                return hour == 0 && minute == 0;
              });
            }
            else{
              let lastN;
              let rainOption = this.rainOption[`${series.instrument_type.defaultHourInterval}:${series.instrument_type.defaultMinuteInterval}`];
              const hourInterval = rainOption.hourInterval * 3600000;
              const minuteInterval = rainOption.minuteInterval * 60 * 1000;
              lastN = (hourInterval + minuteInterval) / series.instrument_type.defaultInterval;
              series.data.forEach((ele, index) => {
                if (!this.$lodash.has(ele, 'originalY')) {
                  ele.originalY = ele.y;
                }
                if (index > 2) {
                  const totalData = this.accumulatedRainGaugeSum({
                    data: series.data,
                    lastN,
                    index,
                  });
                  ele.y = roundTo(totalData, rainDecimals);
                }
              });
            }
          }
        });

        this.options.series = this.options.series.map(series => {
          if (series.type === 'line') {
            return { ...series, data: this.processGaps(series.data) };
          }
          return series;
        });

        const columnCharts = this.options.series.filter(ele => ele.type === 'column');
        
        columnCharts.forEach(series => {
          const newObj = this.$lodash.cloneDeep(series);
          newObj.type = 'scatter';
          newObj.data = newObj.data.filter(data => {
            return data.remark;
          });
          // Scatter series has noSharedTooltip:true and its own headerFormat/pointFormat defaults
          // that show series name + raw {point.x} instead of date + value.
          newObj.tooltip = {
            ...newObj.tooltip,
            headerFormat: '<span style="font-size:10px">{point.key:%Y/%m/%d %H:%M}</span><br/>',
            pointFormat: '<span style="color:{point.color}">●</span> {series.name}: <b>{point.y}</b><br/>',
          };
          this.options.series.push(newObj);
        });
        const instrument = this.selectedInstrument.find(
          instrument => instrument._id === this.alertInstrument._id,
        );
        this.alertInstrument.showTarget.forEach(target => {
          if(instrument){
            const plus_value = this.getAlertValue(`${target}_plus`, instrument);
            const minus_value = this.getAlertValue(`${target}_minus`, instrument);
            if (![null, undefined].includes(plus_value) || ![null, undefined].includes(minus_value)) {
              this.options.series.push({
                name: target,
                color: getStatusColor(target),
                className: this.getStatusClassName(target),
              });
            }
          }
        });
        resolve();
        this.updatetableData();
      });
    },
    getAxisData(yAxisRule_type) {
      return new Promise(resolve => {
        const chart = this.$refs.highcharts.chart;
        this.unitIndex.forEach(ele => {
          const extremes = chart.yAxis[ele.index].getExtremes();
          console.log(yAxisRule_type);
          console.log(`optionChange ${this.optionChange}`);
          console.log(`this.options.yAxis ${this.options.yAxis[ele.index].max} ${this.options.yAxis[ele.index].min} ${this.options.yAxis[ele.index].tickInterval}`);
          console.log(`this.cloneOptions.yAxis ${this.cloneOptions && this.cloneOptions.yAxis && this.cloneOptions.yAxis[ele.index] && this.cloneOptions.yAxis[ele.index].max} ${this.cloneOptions && this.cloneOptions.yAxis && this.cloneOptions.yAxis[ele.index] && this.cloneOptions.yAxis[ele.index].min} ${this.cloneOptions && this.cloneOptions.yAxis && this.cloneOptions.yAxis[ele.index] && this.cloneOptions.yAxis[ele.index].tickInterval}`);
          console.log(`this.userYAxisOptions[index] ${this.userYAxisOptions[ele.unit]} ${this.userYAxisOptions[ele.unit] && this.userYAxisOptions[ele.unit].max} ${this.userYAxisOptions[ele.unit] && this.userYAxisOptions[ele.unit].min} ${this.userYAxisOptions[ele.unit] && this.userYAxisOptions[ele.unit].tickInterval}`);
          console.log(`unitData ${ele.plus} ${ele.minus}`);
          console.log(`extremes ${extremes.max} ${extremes.min}`);
          console.log(`tickInterval ${chart.yAxis[ele.index].tickInterval}`);
          console.log(`this.rescaleChartStateMachine ${this.rescaleChartStateMachine}`);
          switch(yAxisRule_type){
            case 'yAxisRule_beAsIs':
              this.yAxisRule_beAsIs(ele.index, chart.yAxis[ele.index].tickInterval);
              break;
            case 'yAxisRule_beShared':
              this.yAxisRule_beShared(ele.index, ele.unit, chart.yAxis[ele.index].tickInterval);
              break;
            case 'yAxisRule_rescale':
              this.yAxisRule_rescale(ele.index, ele.unit, extremes, chart.yAxis[ele.index].tickInterval, ele);
              break;
            case 'yAxisRule_optionPrecedeAlert':
              this.yAxisRule_optionPrecedeAlert(ele.index, ele.unit, extremes, chart.yAxis[ele.index].tickInterval, ele);
              break;
            case 'yAxisRule_optionPrecedeRescale':
              this.yAxisRule_optionPrecedeRescale(ele.index, ele.unit, extremes, chart.yAxis[ele.index].tickInterval, ele);
              break;
          }
        });
        this.oldYAxis = this.chartOptions.yAxis;
        // console.log(this.options.yAxis);
        this.checkProjectVelocityOption();
        this.cloneOptionsYAxis();

        this.chartReady = true;
        if (this.selectedInstrument.length) {
          this.chartLoading = false;
        }
        resolve();
      });
    },
    accumulatedRainGaugeSum({ data, lastN = 3, index }) {
      const subtractData = data[index - lastN] ? data[index - lastN].originalY : 0;
      let totalData = 0;
      while (lastN >= 0) {
        const addData = data[index - lastN] ? data[index - lastN].originalY : 0;
        totalData += addData;
        lastN = lastN - 1;
      }
      totalData = totalData - subtractData;
      return totalData;
    },
    accumulate1DayRainGaugeSum(data, index, interval) {
      const currentPointTime = data[index].x;
      const targetDayStr = moment(currentPointTime).subtract(1, 'days').format('YYYY-MM-DD');
      
      let totalData = 0;
      let dataCount = 1000 * 60 * 60 * 24 / interval;
      
      let maxLoop = dataCount * 2; 
      let lookback = 1;

      while (lookback <= maxLoop) {
        const checkIndex = index - lookback;
        if (checkIndex < 0) break;

        const checkPt = data[checkIndex];
        const checkPtDayStr = moment(checkPt.x).format('YYYY-MM-DD');

        if (checkPtDayStr === targetDayStr) {
          const addData = this.$lodash.has(checkPt, 'originalY') ? checkPt.originalY : checkPt.y;
          totalData += (addData || 0);
        } else if (moment(checkPt.x).isBefore(moment(targetDayStr, 'YYYY-MM-DD'))) {
          break;
        }

        lookback++;
      }

      return totalData;
    },
    set_x_AxisTickInterval(index, day, hours) {
      this.setChartActiveIndex(index);
      this.customize.xAxisTickInterval.day = day;
      this.customize.xAxisTickInterval.hours = hours;
      this.updatetableData();
    },
    setChartActiveIndex(index) {
      this.chartActiveIndex = index;
    },
    toggleShowRemark() {
      this.showRemark = !this.showRemark;
      this.generateSeries();
    },
    toggleShowVelocity1Hr() {
      this.showVelocity1Hr = !this.showVelocity1Hr;
      this.showVelocity24Hr = false;
      this.groupOption.showVelocity24Hr = this.showVelocity24Hr;
      this.groupOption.showVelocity1Hr = this.showVelocity1Hr;
      this.$emit('submitForm', {name: this.groupName, groupOption: this.groupOption});
    },
    toggleShowVelocity24Hr() {
      this.showVelocity24Hr = !this.showVelocity24Hr;
      this.showVelocity1Hr = false;
      this.groupOption.showVelocity24Hr = this.showVelocity24Hr;
      this.groupOption.showVelocity1Hr = this.showVelocity1Hr;
      this.$emit('submitForm', {name: this.groupName, groupOption: this.groupOption});
    },
    async toggleShowRain1Day() {
      this.enableRain1Day = !this.enableRain1Day;
      await this.rescaleChartBtn('yAxisRule_beAsIs');
      await this.$nextTick();
      if (typeof this.applyFixedYAxisFromProp === 'function') {
        this.applyFixedYAxisFromProp();
      }
    },
    changeLabelSide(value) {
      // 0 at left, 1 at right
      return value ? 0 : 1;
    },
    getAlertValue(target, instrument){
      if(this.showVelocity1Hr && instrument.latestVersion.rate_1Hr_config) return instrument.latestVersion.rate_1Hr_config[target];
      if(this.showVelocity24Hr && instrument.latestVersion.rate_24Hr_config) return instrument.latestVersion.rate_24Hr_config[target];
      return instrument.latestVersion[target];
    },
    onRemarkUpdate() {
      let vm = this;
      this.$emit('getRemarks',() => {
        vm.generateSeries();
      });
    },
    onRemarkFormClose() {
      this.remark.show = false;
      this.remark.editing = {};
    },
    toggleTrendline(event) {
      if(this.selectedInstrument.length>1) {
        this.$notifyError(this.$i18n.t('chart.trendlineError'));
        return;
      }
      this.enableTrendline = !this.enableTrendline;
      let target = event.currentTarget;
      if (target) {
        target.blur();
      }
    },
    getGridLineColor() {
      return GRID_LINE_COLOR_LIST[this.unitIndex.length % GRID_LINE_COLOR_LIST.length];
    },
    getYGridClassName() {
      const classNameList = [
        'highcharts-grid-1',
        'highcharts-grid-2',
        'highcharts-grid-3',
        'highcharts-grid-4',
        'highcharts-grid-5',
      ];
      return classNameList[this.unitIndex.length % classNameList.length];
    },
    getStatusClassName(status) {
      const classNameList = [
        'highcharts-WL-plot',
        'highcharts-AL-plot',
        'highcharts-WSL-plot',
      ];
      const classIndex = classNameList.findIndex(ele => {
        return ele.includes(status);
      });
      return classNameList[classIndex];
    },
    settingShare(){
      let setting = {
        customize: this.$lodash.cloneDeep(this.customize),
        'alertInstrument.showTarget': this.$lodash.cloneDeep(this.alertInstrument.showTarget),
        enableRain1Day: this.enableRain1Day,
        units: [],
      };
      for(let _ of this.options.yAxis){
        const unit = this.$lodash.cloneDeep(_);
        let hourInterval = null;
        let minuteInterval = null;
        if(unit.instrument_type && unit.instrument_type.type === 'rainGauge'){
          hourInterval = this.rainOption[`${unit.instrument_type.defaultHourInterval}:${unit.instrument_type.defaultMinuteInterval}`].hourInterval;
          minuteInterval = this.rainOption[`${unit.instrument_type.defaultHourInterval}:${unit.instrument_type.defaultMinuteInterval}`].minuteInterval;
        }
        setting.units.push({
          name: unit.name,
          'labels.enabled': unit.labels.enabled,
          opposite: unit.opposite,
          min: unit.min,
          max: unit.max,
          tickInterval: unit.tickInterval,
          hourInterval,
          minuteInterval,
        });
      }
      this.$emit('settingShare',setting);
    },
    directUploadSetting(setting){
      // customize
      // alertInstrument.showTarget
      // unit.name
      // unit.labels.enabled
      // unit.opposite
      // unit.min
      // unit.max
      // unit.tickInterval
      // rainOption[`${unit.instrument_type.defaultHourInterval}:${unit.instrument_type.defaultMinuteInterval}`].hourInterval
      // rainOption[`${unit.instrument_type.defaultHourInterval}:${unit.instrument_type.defaultMinuteInterval}`].minuteInterval
      // unit.instrument_type.minuteIntervalStep
      this.customize = setting.customize;
      if(this.enableRain1Day != setting.enableRain1Day){
        this.enableRain1Day = setting.enableRain1Day;
        this.rescaleChartBtn('yAxisRule_beAsIs');
      }
      this.alertInstrument.showTarget = setting['alertInstrument.showTarget'];
      for(let unit of setting.units){
        let index = this.options.yAxis.findIndex(ele=>{
          return ele.name === unit.name;
        });
        if(index>-1){
          //console.log(unit);
          if(!this.userYAxisOptions[unit.name]){
            this.userYAxisOptions[unit.name] = {};
          }
          this.userYAxisOptions[unit.name].max = unit.max;
          this.userYAxisOptions[unit.name].min = unit.min;
          this.userYAxisOptions[unit.name].tickInterval = unit.tickInterval;

          let _ = this.options.yAxis[index];
          this.options.yAxis[index].labels.enabled = unit['labels.enabled'];
          this.options.yAxis[index].opposite = unit.opposite;
          this.options.yAxis[index].min = unit.min;
          this.options.yAxis[index].max = unit.max;
          this.options.yAxis[index].tickInterval = unit.tickInterval;
          

          if(_.instrument_type && _.instrument_type.type === 'rainGauge'){
            this.rainOption[`${_.instrument_type.defaultHourInterval}:${_.instrument_type.defaultMinuteInterval}`].hourInterval = unit.hourInterval;
            this.rainOption[`${_.instrument_type.defaultHourInterval}:${_.instrument_type.defaultMinuteInterval}`].minuteInterval = unit.minuteInterval;
          }
        }
      }
      this.cloneOptionsYAxis();
    },    
    cloneOptionsYAxis() {
      console.log('cloneOptionsYAxis');
      this.cloneOptions = {};
      this.cloneOptions.yAxis = this.$lodash.cloneDeep(this.options.yAxis);
      //this.cloneOptions.yAxis = '';
      this.cloneOptions.yAxis = this.cloneOptions.yAxis.map(unit => ({
        ...unit,
        yAxisTitle: unit.yAxisTitle ?? unit.title.text ?? '',   // 若已存在就保留
      }));
      console.log(this.$lodash.cloneDeep(this.cloneOptions.yAxis));
      console.log(this.cloneOptions);
    },
    handleCloseDrawer(done){
      console.log('handleCloseDrawer');
      //console.log(this.$lodash.cloneDeep(this.cloneOptions.yAxis));
      this.options.yAxis = this.$lodash.cloneDeep(this.cloneOptions.yAxis);
      //this.cloneOptions.yAxis = null;
      if(this.optionChange){
        this.unitIndex.forEach(ele=>{
          const index = ele.index;
          this.userYAxisOptions[ele.unit] = {
            max: this.cloneOptions.yAxis[index].max,
            min: this.cloneOptions.yAxis[index].min,
            interval: this.cloneOptions.yAxis[index].interval,
            startOnTick: this.cloneOptions.yAxis[index].startOnTick,
            endOnTick: this.cloneOptions.yAxis[index].endOnTick,
            opposite: this.cloneOptions.yAxis[index].opposite,
            tickInterval: this.cloneOptions.yAxis[index].tickInterval,
            //labelsEnabled: this.cloneOptions.yAxis.labels.enabled,
          };

          //console.log('setting!');
          //console.log(`this.options.yAxis ${this.options.yAxis[ele.index].max} ${this.options.yAxis[ele.index].min}`);
          //console.log(`this.cloneOptions.yAxis ${this.cloneOptions && this.cloneOptions.yAxis && this.cloneOptions.yAxis[ele.index] && this.cloneOptions.yAxis[ele.index].max} ${this.cloneOptions && this.cloneOptions.yAxis && this.cloneOptions.yAxis[ele.index] && this.cloneOptions.yAxis[ele.index].min}`);
          //console.log(`this.userYAxisOptions[index] ${this.userYAxisOptions[ele.index]} ${this.userYAxisOptions[ele.index] && this.userYAxisOptions[ele.index].max} ${this.userYAxisOptions[ele.index] && this.userYAxisOptions[ele.index].min}`);
          //console.log(`unitData ${ele.plus} ${ele.minus}`);
          //console.log(`extremes ${null} ${null}`);
        });

        this.optionChange = false;
      }

      this.$forceUpdate();
      done?.();
    },
    handleChange(){
      //console.log('handleSwitchChange');
      //console.log(this.cloneOptions.yAxis);
      this.$forceUpdate();
    },
    handleOptionChange(){
      this.optionChange = true;
    },
    updateTable() {
      setTimeout(() => {
        this.$refs.hot.hotInstance.loadData(this.hotSettings.data);
      }, 100);
    },
    handlePointClick(event) {
      console.log('click');
      if (this.hasAccess.remark) {
        this.remark.instrument = event.point.instrument;
        this.remark.timestamp = event.point.x;
        if (event.point.remark) {
          const remark = event.point.remark;
          this.remark.formType = 'edit';
          this.remark.editing = remark;
        } else {
          this.remark.formType = 'create';
        }
        this.remark.show = true;
      }
    },

    tooltipFormatter(tooltip) {
      const vm = this;
      if (!vm.showRemark || !this.points) {
        return tooltip.defaultFormatter.call(this, tooltip);
      }
      const remarks = this.points
        .map(ele => {
          if (ele.point.remark) {
            return {
              content: ele.point.remark.content,
              color: ele.point.color,
            };
          }
        })
        .filter(ele => ele !== undefined);
      if (remarks.length > 0) {
        const defaultTooltip = tooltip.defaultFormatter.call(this, tooltip);
        remarks.forEach((remark, index) => {
          //if (index === 0) {
          //  const gap = '<span style="margin-top:8px"></span></br>';
          //  defaultTooltip.push(gap);
          //}
          //const remarkHtml = `<span style="color:${remark.color}">▲</span><span style="font-weight:bold; font-size:14px"> ${remark.content}</span><br/>`;
          const remarkHtml = remark.content;
          defaultTooltip.push(remarkHtml);
        });
        return defaultTooltip;
      }
      return tooltip.defaultFormatter.call(this, tooltip);
    },

    labelFormatter() {
      const vm = this;
      // if (this.isFirst || this.isLast) {
      if (this.isFirst) {
        const timestamp = vm.$moment(this.value);
        const hour = timestamp.hour();
        const minute = timestamp.minute();
        if (hour === 0 && minute === 0) {
          return vm.$moment(this.value).format('YYYY/MM/DD');
        } else {
          return vm.$moment(this.value).format('YYYY/MM/DD HH:mm');
        }
      } else {
        return this.axis.defaultLabelFormatter.call(this);
      }
    },

    yAxisRule_beAsIs(index, tickInterval) {
      //依照原樣
      if(this.cloneOptions && this.cloneOptions.yAxis){
        this.options.yAxis[index].max = this.cloneOptions.yAxis[index].max;
        this.options.yAxis[index].min = this.cloneOptions.yAxis[index].min;
        this.options.yAxis[index].tickInterval = this.cloneOptions.yAxis[index].tickInterval;
      }

      //this.options.yAxis[index].tickInterval = tickInterval;
      //let range = this.options.yAxis[index].max - this.options.yAxis[index].min;
      //if (Math.abs(range) / this.options.yAxis[index].tickInterval > 6 || Math.abs(range) / this.options.yAxis[index].tickInterval < 1) {
      //  if (this.showVelocity1Hr || Math.abs(range) * this.options.yAxis[index].tickInterval < 1) {
      //    this.options.yAxis[index].tickInterval = Math.round(range / 5 * 10) / 10;
      //  } else {
      //    this.options.yAxis[index].tickInterval = Math.ceil(range / 5);
      //  }
      //}
      this.options.yAxis[index].startOnTick = this.cloneOptions.yAxis[index].startOnTick;
      this.options.yAxis[index].endOnTick = this.cloneOptions.yAxis[index].endOnTick;
    },
    yAxisRule_beShared(index, unit, tickInterval) {
      //視為使用者的設定，將分享的內容套用到使用者的設定之中
      if(!this.userYAxisOptions || !this.userYAxisOptions[unit]) return;
      if(![null,undefined,NaN,false].includes(this.userYAxisOptions[unit].max)) this.options.yAxis[index].max = this.userYAxisOptions[unit].max;
      if(![null,undefined,NaN,false].includes(this.userYAxisOptions[unit].min)) this.options.yAxis[index].min = this.userYAxisOptions[unit].min;

      if(![null,undefined,NaN,false,0].includes(this.userYAxisOptions[unit].tickInterval)){
        this.options.yAxis[index].tickInterval = this.userYAxisOptions[unit].tickInterval;
      }
      else{
        this.options.yAxis[index].tickInterval = tickInterval;
        let range = this.options.yAxis[index].max - this.options.yAxis[index].min;
        if (Math.abs(range) / this.options.yAxis[index].tickInterval > 6 || Math.abs(range) / this.options.yAxis[index].tickInterval < 1) {
          if (this.showVelocity1Hr || Math.abs(range) * this.options.yAxis[index].tickInterval < 1) {
            this.options.yAxis[index].tickInterval = Math.round(range / 5 * 10) / 10;
          } else {
            this.options.yAxis[index].tickInterval = Math.ceil(range / 5);
          }
        }
      }
      this.options.yAxis[index].startOnTick = this.userYAxisOptions[unit].startOnTick;
      this.options.yAxis[index].endOnTick = this.userYAxisOptions[unit].endOnTick;
    },
    yAxisRule_rescale(index, unit, extremes, tickInterval, unitData) {
      //重置使用者的設定，並在警戒值上下限與自動縮放之間切換
      this.userYAxisOptions[unit] = null;
      
      if (this.rescaleChartStateMachine) {
        // === 修改開始 (Max 部分) ===
        // 取得數據的最大值 (dataMax)，如果沒有數據則回退到 Highcharts 計算的 max
        const dataMax = extremes.dataMax !== undefined ? extremes.dataMax : extremes.max;
        
        // 判斷：若有設定 Plus (警戒上限)
        if (![null, undefined, NaN, false].includes(unitData.plus)) {
          // 如果「數據最大值」大於「警戒上限」，則使用數據最大值 (讓點顯示出來)
          // 否則維持使用警戒上限 (讓警戒線置頂)
          this.options.yAxis[index].max = (dataMax > unitData.plus) ? dataMax : unitData.plus;
        } else {
          this.options.yAxis[index].max = extremes.max;
        }
        // === 修改結束 ===

        // === 修改開始 (Min 部分) ===
        // 取得數據的最小值
        const dataMin = extremes.dataMin !== undefined ? extremes.dataMin : extremes.min;

        // 判斷：若有設定 Minus (警戒下限)
        if (![null, undefined, NaN, false].includes(unitData.minus)) {
          // 如果「數據最小值」小於「警戒下限」，則使用數據最小值
          this.options.yAxis[index].min = (dataMin < unitData.minus) ? dataMin : unitData.minus;
        } else {
          this.options.yAxis[index].min = extremes.min;
        }
        // === 修改結束 ===

      } else {
        this.options.yAxis[index].max = extremes.max;
        this.options.yAxis[index].min = extremes.min;
      }

      // 以下保持原樣
      this.options.yAxis[index].tickInterval = tickInterval;
      let range = this.options.yAxis[index].max - this.options.yAxis[index].min;
      
      if (Math.abs(range) / this.options.yAxis[index].tickInterval > 6 || Math.abs(range) / this.options.yAxis[index].tickInterval < 1) {
        if (this.showVelocity1Hr || Math.abs(range) * this.options.yAxis[index].tickInterval < 1) {
          this.options.yAxis[index].tickInterval = Math.round(range / 5 * 10) / 10;
        } else {
          this.options.yAxis[index].tickInterval = Math.ceil(range / 5);
        }
      }
      this.options.yAxis[index].startOnTick = true;
      this.options.yAxis[index].endOnTick = true;
    },
    yAxisRule_optionPrecedeAlert(index, unit, extremes, tickInterval, unitData) {
      //若有使用者的設定，則使用使用者的設定；若無，則使用警戒值；若無警戒值，則自動調整
      if(this.userYAxisOptions[unit]){
        if(![null,undefined,NaN,false].includes(this.userYAxisOptions[unit].max)){
          this.options.yAxis[index].max = this.userYAxisOptions[unit].max;
        }
        else{
          this.options.yAxis[index].max = ![null,undefined,NaN,false].includes(unitData.plus)  ? unitData.plus  : extremes.max;
        }
        if(![null,undefined,NaN,false].includes(this.userYAxisOptions[unit].min)){
          this.options.yAxis[index].min = this.userYAxisOptions[unit].min;
        }
        else{
          this.options.yAxis[index].min = ![null,undefined,NaN,false].includes(unitData.minus)  ? unitData.minus  : extremes.min;
        }

        if(![null,undefined,NaN,false,0].includes(this.userYAxisOptions[unit].tickInterval)){
          this.options.yAxis[index].tickInterval = this.userYAxisOptions[unit].tickInterval;
        }
        else{
          this.options.yAxis[index].tickInterval = tickInterval;
          let range = this.options.yAxis[index].max - this.options.yAxis[index].min;
          if (Math.abs(range) / this.options.yAxis[index].tickInterval > 6 || Math.abs(range) / this.options.yAxis[index].tickInterval < 1) {
            if (this.showVelocity1Hr || Math.abs(range) * this.options.yAxis[index].tickInterval < 1) {
              this.options.yAxis[index].tickInterval = Math.round(range / 5 * 10) / 10;
            } else {
              this.options.yAxis[index].tickInterval = Math.ceil(range / 5);
            }
          }
        }
        this.options.yAxis[index].startOnTick = this.userYAxisOptions[unit].startOnTick;
        this.options.yAxis[index].endOnTick = this.userYAxisOptions[unit].endOnTick;
      }
      else {
        this.options.yAxis[index].max = ![null,undefined,NaN,false].includes(unitData.plus)  ? unitData.plus  : extremes.max;
        this.options.yAxis[index].min = ![null,undefined,NaN,false].includes(unitData.minus) ? unitData.minus : extremes.min;
        this.options.yAxis[index].tickInterval = tickInterval;
        let range = this.options.yAxis[index].max - this.options.yAxis[index].min;
        if (Math.abs(range) / this.options.yAxis[index].tickInterval > 6 || Math.abs(range) / this.options.yAxis[index].tickInterval < 1) {
          if (this.showVelocity1Hr || Math.abs(range) * this.options.yAxis[index].tickInterval < 1) {
            this.options.yAxis[index].tickInterval = Math.round(range / 5 * 10) / 10;
          } else {
            this.options.yAxis[index].tickInterval = Math.ceil(range / 5);
          }
        }
        this.options.yAxis[index].startOnTick = true;
        this.options.yAxis[index].endOnTick = true;
      }
    },
    yAxisRule_optionPrecedeRescale(index, unit, extremes, tickInterval, unitData) {
      //若有使用者的設定，則使用使用者的設定；若無，按照rescale切換的內容
      
      if(this.userYAxisOptions[unit]){
        //console.log(this.userYAxisOptions[unit]);
        if(![null,undefined,NaN,false].includes(this.userYAxisOptions[unit].max)){
          this.options.yAxis[index].max = this.userYAxisOptions[unit].max;
        }
        else {
          // 這裡也要改：如果使用者沒設 max，但有自動邏輯
          const dataMax = extremes.dataMax !== undefined ? extremes.dataMax : extremes.max;
          const targetPlus = ![null, undefined, NaN, false].includes(unitData.plus) ? unitData.plus : extremes.max;
          this.options.yAxis[index].max = (dataMax > unitData.plus && unitData.plus) ? dataMax : targetPlus;
        }
        if(![null,undefined,NaN,false].includes(this.userYAxisOptions[unit].min)){
          this.options.yAxis[index].min = this.userYAxisOptions[unit].min;
        } else {
          const dataMin = extremes.dataMin !== undefined ? extremes.dataMin : extremes.min;
          const targetMinus = ![null, undefined, NaN, false].includes(unitData.minus) ? unitData.minus : extremes.min;
          this.options.yAxis[index].min = (dataMin < unitData.minus && unitData.minus) ? dataMin : targetMinus;
        }

        if(![null,undefined,NaN,false].includes(this.userYAxisOptions[unit].tickInterval)){
          this.options.yAxis[index].tickInterval = this.userYAxisOptions[unit].tickInterval;
        }
        else{
          this.options.yAxis[index].tickInterval = tickInterval;
          let range = this.options.yAxis[index].max - this.options.yAxis[index].min;
          if (Math.abs(range) / this.options.yAxis[index].tickInterval > 6 || Math.abs(range) / this.options.yAxis[index].tickInterval < 1) {
            if (this.showVelocity1Hr || Math.abs(range) * this.options.yAxis[index].tickInterval < 1) {
              this.options.yAxis[index].tickInterval = Math.round(range / 5 * 10) / 10;
            } else {
              this.options.yAxis[index].tickInterval = Math.ceil(range / 5);
            }
          }
        }
        
        this.options.yAxis[index].startOnTick = this.userYAxisOptions[unit].startOnTick;
        this.options.yAxis[index].endOnTick = this.userYAxisOptions[unit].endOnTick;
      }
      else {
        console.log(`test now , max: ${extremes.max} , min: ${extremes.min}`);
        console.log(`plus: ${unitData.plus} , minus: ${unitData.minus} , 狀態機: ${this.rescaleChartStateMachine}`);
        if (this.rescaleChartStateMachine) {
          // 準備數據極值
          const dataMax = extremes.dataMax !== undefined ? extremes.dataMax : extremes.max;
          const dataMin = extremes.dataMin !== undefined ? extremes.dataMin : extremes.min;

          // === 設定 Max ===
          if (![null, undefined, NaN, false].includes(unitData.plus)) {
            // 比較：若 Data > Plus，用 Data；否則用 Plus
            this.options.yAxis[index].max = (dataMax > unitData.plus) ? dataMax : unitData.plus;
          } else {
            this.options.yAxis[index].max = undefined; // 讓 Highcharts 自動決定
          }

          // === 設定 Min ===
          if (![null, undefined, NaN, false].includes(unitData.minus)) {
            // 比較：若 Data < Minus，用 Data；否則用 Minus
            this.options.yAxis[index].min = (dataMin < unitData.minus) ? dataMin : unitData.minus;
          } else {
            this.options.yAxis[index].min = undefined; // 讓 Highcharts 自動決定
          }
          
        } else {
          this.options.yAxis[index].max = undefined;
          this.options.yAxis[index].min = undefined;
        }

        this.options.yAxis[index].tickInterval = tickInterval;
        
        // 重新計算範圍來決定 Tick (因為 min/max 可能變了)
        // 注意：若 min/max 是 undefined，這裡計算 range 會變成 NaN，Highcharts 會自己處理，但建議做個防呆
        let currentMax = this.options.yAxis[index].max !== undefined ? this.options.yAxis[index].max : extremes.max;
        let currentMin = this.options.yAxis[index].min !== undefined ? this.options.yAxis[index].min : extremes.min;
        let range = currentMax - currentMin;

        if (Math.abs(range) / this.options.yAxis[index].tickInterval > 6 || Math.abs(range) / this.options.yAxis[index].tickInterval < 1) {
          if (this.showVelocity1Hr || Math.abs(range) * this.options.yAxis[index].tickInterval < 1) {
            this.options.yAxis[index].tickInterval = Math.round(range / 5 * 10) / 10;
          } else {
            this.options.yAxis[index].tickInterval = Math.ceil(range / 5);
          }
        }
        this.options.yAxis[index].startOnTick = true;
        this.options.yAxis[index].endOnTick = true;
      }
    },

    async loadScale(index) {
      console.log('load scale');
      this.$notifyInfo(this.$t('Notify.info'),this.$t('chart.info.loadScale'));

      const namedStyle = await this.getProjectInstrumentNamedStyle();
      let instrument_type = '';
      let ins_name = this.selectedInstrument[0].latestVersion.name;

      if(namedStyle){
        let match = namedStyle.exec(ins_name);
        console.log(namedStyle);
        console.log(match);
        instrument_type = match?.groups?.['device'];
        if(!instrument_type) instrument_type = this.selectedInstrument[0].latestVersion.unit;
      }
      else {
        instrument_type = this.selectedInstrument[0].latestVersion.unit;
      }

      instrument_type = this.autoTranslate(instrument_type);

      const res = await this.$axios({
        category: 'user',
        method: 'get',
        apiName: `getUserScaleSetting/${this.selectedProject._id}/${instrument_type}`,
        useUrl: this.useUrl ? 'https://api-thsr-rain.geosupply.com.tw/' : null,
      });

      console.log(res.data);
      
      const unit = this.cloneOptions.yAxis[index];     // 只取一次路徑
      console.log(unit);
      Object.assign(unit, {
        max:          res.data.scaleMax      ?? unit.max,
        min:          res.data.scaleMin      ?? unit.min,
        tickInterval: res.data.scaleInterval ?? unit.tickInterval,
      });


      this.$notifySuccess(this.$t('chart.success.load'));
      this.handleCloseDrawer();
    },

    async saveScale(index) {
      console.log('save scale');
      this.$notifyInfo(this.$t('Notify.info'),this.$t('chart.info.saveScale'));

      const namedStyle = await this.getProjectInstrumentNamedStyle();
      let instrument_type = '';
      let ins_name = this.selectedInstrument[0].latestVersion.name;
      const chart = this.$refs.highcharts.chart;
      const extremes = chart.yAxis[index].getExtremes();  

      if(namedStyle){
        // /(?<route>[A-Za-z0-9]{2,5})-(?<instrument_type>[A-Za-z0-9]{2,3})-(?<serial>[\w()\-]+)/g;
        // ^TK(?<km>\\d+)\\+(?<m>\\d{1,3})(?<side>[EWabcd])?(?:\\((?<device_remark_0>[^)]*)\\))?-(?<device>[A-Z]{2,4})-(?<level>\\d+)(?:\\((?<device_remark_1>[^)]*)\\))?(?:-(?<device_remark_2>[A-Z]{1,2}))?$ 
        let match = namedStyle.exec(ins_name);
        console.log(namedStyle);
        console.log(match);
        instrument_type = match?.groups?.['device'];
        if(!instrument_type) instrument_type = this.selectedInstrument[0].latestVersion.unit;
      }
      else {
        instrument_type = this.selectedInstrument[0].latestVersion.unit;
      }

      instrument_type = this.autoTranslate(instrument_type);

      if(instrument_type){
        // 取得Y軸上下限與X軸間隔
        // 再來上傳
        const unit = this.cloneOptions.yAxis[index];
        let scaleMax = unit.max ?? extremes.max;
        let scaleMin = unit.min ?? extremes.min;
        let scaleInterval = unit.tickInterval;

        const payload = {
          scaleMax,
          scaleMin,
          scaleInterval,
          project: this.selectedProject._id,
          instrument_type,
        };

        console.log('▶ uploadUserScaleSetting payload:', payload);


        this.$axios({
          category: 'user',
          method: 'post',
          apiName: 'uploadUserScaleSetting',
          data: payload,
          useUrl: this.useUrl ? 'https://api-thsr-rain.geosupply.com.tw/' : null,
        });

        this.$notifySuccess(this.$t('chart.success.save'));
        this.handleCloseDrawer();
      }
    },

    autoTranslate(instrument_type){
      if(instrument_type.includes('%')) return instrument_type.replace('%','pa');
      return instrument_type;
    },

    async getProjectInstrumentNamedStyle() {
      let instrumentNamedStyle = this.selectedProject.instrumentNamedStyle;
      if(!instrumentNamedStyle){
        const res = await this.$axios({
          category: 'project',
          method: 'get',
          apiName: `${this.selectedProject._id}/instrument-named-style`,
          useUrl: this.useUrl ? 'https://api-thsr-rain.geosupply.com.tw/' : null,
        });
        instrumentNamedStyle = res.data;
      }

      return new RegExp(instrumentNamedStyle);
    },

    submitChartTitleChange() {
      console.log(this.customize.chartTitle);
    },
    submitxAxisTitleChange() {
      console.log(this.customize.xAxisTitle);
    },
    submityAxisTitleChange(index) {
      console.log(this.cloneOptions.yAxis[index].yAxisTitle);
      this.cloneOptions.yAxis[index].title.text = this.cloneOptions.yAxis[index].yAxisTitle;
      this.options.yAxis[index].title.text =  this.cloneOptions.yAxis[index].yAxisTitle;
      this.$forceUpdate();
    },
  },
};

</script>

<style lang="stylus">
.el-scrollbar__wrap 
  height: 360px !important
.el-cascader__tags .el-tag > span
  flex-basis auto
.el-drawer__body
  overflow auto
.chart-container .el-card__body{
  min-height: 400px;
  padding: 5px !important;
}
.columns-chart{
  display: block;
  flex-basis: 0;
  flex-grow: 1;
  flex-shrink: 1;
  flex: none;
  width: 100%;
  padding-top: 0px;
  padding-right: 12px;
  padding-bottom: 0px;
  padding-left: 12px;
}

.highcharts-axis-labels {
  font-weight: 700;
  font-size: 13px;
}

.highcharts-grid-top {
  .highcharts-grid-line {
      stroke: #e6e6e6;
    }
}

.highcharts-grid-1 {
  .highcharts-grid-line {
    stroke: #96F8EC;
  }  
}

.highcharts-grid-2 {
  .highcharts-grid-line {
    stroke: #D2B6D2;
  }  
}

.highcharts-grid-3 {
  .highcharts-grid-line {
    stroke: #98F898;
  }  
}

.highcharts-grid-4 {
  .highcharts-grid-line {
    stroke: #FF94A6;
  }  
}

.highcharts-grid-5 {
  .highcharts-grid-line {
    stroke: #F3F196;
  }  
}

.highcharts-WL-plot {
  stroke: #4188ff !important;
  fill: #4188ff;
  stroke-width: 2px;
}

.highcharts-AL-plot {
  stroke: #ffad00 !important;
  fill: #ffad00;
  stroke-width: 2px;
}

.highcharts-WSL-plot {
  stroke: #ff0000 !important;
  fill: #ff0000;
  stroke-width: 2px;
}

.highcharts-tooltip-box .highcharts-label-box {
  fill: #f7f7f7 !important;
  fill-opacity: 0.4 !important;
}

.tooltip-box .highcharts-label-box {
  fill: #f7f7f7 !important;
  fill-opacity: 0.4 !important;
}

.highcharts-xaxis-grid .highcharts-grid-line {
  stroke-width: 1px;
}

</style>

<style lang="stylus" scoped>
.el-input-number
  max-width 150px
.el-form-item__label
  font-weight bold
.el-radio-button.is-active
  z-index 10
.el-row
  margin-bottom 1.5rem
.interval-button
  margin-left 10px
.input-label-right
  margin-left 10px
.button-primary
  color #FFF
  background-color #409EFF
  border-color #409EFF
  box-shadow -1px 0 0 0 #409EFF
.date-range-seperate
  margin 0 1rem
.card-header__bar
  border-style solid
  border-width 4px 0 0
</style>